import { memo } from 'react'

import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

import CheckboxField from '../CheckboxField/CheckboxField'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export interface AutocompleteFieldOptionBodyProps {
  name: string
  optionValue: string | number
  checkbox?: boolean
  selected: boolean
  label: React.ReactNode
}

// Inner body (checkbox + label) of a single option, shared by BOTH the
// non-virtualized `<li>` renderer and the virtualized row renderer so the
// option markup never forks between the two paths. The `<li>` wrapper itself
// stays in each caller because MUI owns the `<li>` props (key, role, handlers)
// in the non-virtualized path and react-window positions the `<li>` in the
// virtualized path.
const _AutocompleteFieldOptionBody = (props: AutocompleteFieldOptionBodyProps) => {
  const { name, optionValue, checkbox, selected, label } = props

  return (
    <>
      {checkbox && (
        <CheckboxField name={`${name}-${optionValue}`} icon={icon} checkedIcon={checkedIcon} checked={selected} />
      )}
      {label}
    </>
  )
}

const AutocompleteFieldOptionBody = memo(_AutocompleteFieldOptionBody) as typeof _AutocompleteFieldOptionBody
export default AutocompleteFieldOptionBody
